import { formatEuro } from "./format-euro";

try {
  const recalculate = () => {
    const basketItemEls = document.querySelectorAll("[data-basket-item]");
    const basketItemTotalEl = document.querySelector("[data-basket-item-total]");

    let total = 0;

    basketItemEls.forEach((basketItemEl) => {
      const priceEl = basketItemEl.querySelector("[data-basket-item-price]");
      const amountEl = basketItemEl.querySelector("[data-basket-item-amount]");
      const subtotalEl = basketItemEl.querySelector("[data-basket-item-subtotal]");

      if (priceEl && amountEl && subtotalEl) {
        const price = parseFloat(priceEl.dataset.basketItemPrice);
        const amount = parseInt(amountEl.value);
        if (price && amount >= 0 && price > 0) {
          const subtotal = price * amount;
          subtotalEl.innerText = formatEuro(subtotal);
          total += subtotal;
        }
      }
    });

    if (basketItemTotalEl) {
      basketItemTotalEl.innerText = formatEuro(total);
    }
  };

  recalculate();
  document.addEventListener("addItem:success", () => {
    recalculate();
  });
} catch (error) {}
